export default __webpack_public_path__ + "static/logo-80a6be6a9f5b85b53d73f15bd7d890a0.png";